module.exports = __webpack_public_path__ + "img/leftUpZj.e929d224.png";